import { render, staticRenderFns } from "./TooltipsComponent.vue?vue&type=template&id=05a5d726&scoped=true"
import script from "./TooltipsComponent.vue?vue&type=script&lang=js"
export * from "./TooltipsComponent.vue?vue&type=script&lang=js"
import style0 from "./TooltipsComponent.vue?vue&type=style&index=0&id=05a5d726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a5d726",
  null
  
)

export default component.exports